import { useGameStore } from '../game/store';
import { startTickLoop, stopTickLoop } from '../game/store';

export function PauseOverlay(): JSX.Element | null {
  const status = useGameStore((s) => s.world.status);
  const togglePause = useGameStore((s) => s.togglePause);

  if (status !== 'PAUSED') return null;
  return (
    <div className="overlay">
      <div className="overlay-card">
        <h2>Paused</h2>
        <button
          className="primary"
          onClick={() => {
            stopTickLoop();
            togglePause();
            startTickLoop();
          }}
        >
          Resume
        </button>
      </div>
    </div>
  );
}
